import { IExportData } from "@/pages/export-list/types";
import { getTranslateNsT } from "@/utils/getTranslateNsT";
import { dateFormatter, FormatType } from "project-config/utils/date-formatter";
import { ColumnType } from "antd/es/table/interface";
import { Tooltip } from "@renderbus/ui";
import { getDomain } from "project-config/utils/domain";

export const getTableColumns: (
  is88StudioSubAccount: boolean
) => ColumnType<IExportData>[] = (is88StudioSubAccount) => {
  const t = getTranslateNsT("consumption");
  return [
    // 账期
    {
      title: t("consumption_time_selector"),
      dataIndex: "feeTime",
      render: (v) => dateFormatter(v, FormatType.YMD),
    },
    //计费方式
    {
      title: t("consumption_label_fee_type"),
      dataIndex: "feeType",
      render: (row) => t(`consumption_fee_type_${row}`),
    },
    {
      title: t("consumption_label_organization_type"),
      dataIndex: "organizationStructure",
      render: (v) => (
        <>
          {(v ?? "").split("\n").map((item: string) => {
            return <div key={item}>{item}</div>;
          })}
        </>
      ),
    },
    {
      dataIndex: "submitUserName",
      title: t("user_operate_record_submit_account"),
    },
    {
      dataIndex: "userName",
      title: t("user_operate_record_user_name_alias"),
    },
    // 制作人
    {
      title: t("user_consume_table_sort_producer"),
      dataIndex: "producer",
    },
    //支付来源
    {
      title: t("bill_recharge_from"),
      dataIndex: "accountType",
      render: (v) => t(`consumption_account_type_${v}`),
    },
    {
      title: t("consumption_table_header_company"),
      key: "company",
      ellipsis: true,
      render: (v) => <ContentWithToolTip content={v.company} />,
    },
    {
      title: t("user_com_childPro_name_place"),
      key: "projectName",
      ellipsis: true,
      render: (v) => <ContentWithToolTip content={v.projectName} />,
    },
    {
      title: t("user_consume_table_sort_id"),
      dataIndex: "taskId",
    },
    {
      title: t("analysis_table_header_name"),
      key: "sceneName",
      ellipsis: true,
      render: (v) => <ContentWithToolTip content={v.sceneName} />,
    },
    {
      dataIndex: "framesRange",
      title: t("user_consume_table_sort_frame_rank"),
    },
    {
      dataIndex: "layerName",
      title: t("user_consume_table_sort_layer"),
    },
    {
      dataIndex: "renderCamera",
      title: t("user_consume_table_sort_camera"),
    },
    {
      title: t("user_consume_table_sort_frame_total"),
      dataIndex: "totalFrames",
    },
    {
      dataIndex: "averageDuration",
      title: t("user_consume_table_sort_average_duration"),
    },
    {
      dataIndex: "platformName",
      title: t("user_consume_pick_platform"),
    },
    {
      dataIndex: "cgName",
      title: t("consumption_cg_name"),
    },
    {
      dataIndex: "startTime",
      title: t("user_consume_table_sort_submit_date"),
      render: (v) => dateFormatter(v),
    },
    {
      dataIndex: "model",
      title: t("consumption_gpu_model"),
    },
    {
      dataIndex: "graphicsCardsNum",
      title: t("consumption_gpu_number"),
    },
    {
      dataIndex: "taskRam",
      title: t("consumption_memory"),
    },
    {
      dataIndex: "feeDuration",
      title: t("consumption_render_duration"),
      render: (v) => v + t(`seconds`),
    },
    !is88StudioSubAccount
      ? {
          dataIndex: "currency",
          title: t("consumption_currency"),
          render: (row) => (row === 1 ? "RMB" : "USD"),
        }
      : {},
    !is88StudioSubAccount
      ? {
          dataIndex: "feeAmount",
          title: t("consumption_balance_consume"),
        }
      : {},
    !is88StudioSubAccount
      ? {
          dataIndex: "couponFeeAmount",
          title: t("consumption_coupon_consume"),
        }
      : {},
    !getDomain()
      ? {
          dataIndex: "couponQYFeeAmount",
          title: t("consumption_youth_coupon_consume"),
        }
      : {},
    !getDomain()
      ? {
          dataIndex: "voucherFeeAmount",
          title: t("consumption_voucher_fee_amount"),
        }
      : {},
    {
      dataIndex: "resolution",
      title: t("consumption_resolution_ratio"),
    },
  ];
};

export function ContentWithToolTip({
  maxWidth = 220,
  fontSize = 14,
  content,
}: {
  maxWidth?: number;
  fontSize?: number;
  content: string | number;
}) {
  if (String(content).length * fontSize > maxWidth) {
    return (
      <Tooltip
        placement="top"
        title={content}
        color={"#202124"}
        triggerBody={document.body}
        tooltipText={<div style={{ maxWidth: `${maxWidth}px` }}>{content}</div>}
      />
    );
  }
  return <span>{content}</span>;
}
